import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledLabel,
  StyledBoxModule,
  StyledOrderItem,
  StyledIcon
} from './style';
import {
  StyleWrapIcon,
  StyledBoxInputDivision,
  StyledBoxInputDivisionTwo
} from './styleVolunteer';

import Input from '../../../core/Input';
import { VOLUNTEER } from '../../../../constants/literals/modals';
import { Trash } from '../../../../../assets/images';

const VolunteerItem = ({
  onChangeInputOrganization,
  onChangeInputRole,
  onClickDown,
  onClickUp,
  onClickDelete,
  order,
  organization,
  role,
  errorOrganization,
  errorRole
}) => (
  <StyledBoxModule>
    <StyledOrderItem
      order={order}
      onClickDown={onClickDown}
      onClickUp={onClickUp}
    />
    <StyledBoxInputDivision>
      <StyledLabel>{VOLUNTEER.ORGANIZATION}</StyledLabel>
      <Input
        onChange={onChangeInputOrganization}
        value={organization}
        error={errorOrganization}
      />
    </StyledBoxInputDivision>
    <StyledBoxInputDivisionTwo>
      <StyledLabel>{VOLUNTEER.FUNCTION}</StyledLabel>
      <Input onChange={onChangeInputRole} value={role} error={errorRole} />
    </StyledBoxInputDivisionTwo>
    <StyleWrapIcon>
      <StyledIcon svg={Trash} size="m" hover onClick={onClickDelete} />
    </StyleWrapIcon>
  </StyledBoxModule>
);

VolunteerItem.propTypes = {
  onChangeInputOrganization: PropTypes.func,
  onChangeInputRole: PropTypes.func,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  onClickDelete: PropTypes.func,
  order: PropTypes.number,
  organization: PropTypes.string,
  role: PropTypes.string,
  errorOrganization: PropTypes.bool,
  errorRole: PropTypes.bool
};

VolunteerItem.defaultProps = {
  order: 0,
  organization: '',
  role: '',
  errorOrganization: false,
  errorRole: false
};

export default VolunteerItem;
